import { z } from 'zod';

export const MindEntityKind = z.enum([
  'PROJECT',
  'WORK_ITEM',
  'REQUEST',
  'COMMENT',
  'PROGRESS_ENTRY',
  'EVIDENCE',
  'COMPLETION_EPISODE',
  'PROJECT_UPDATE',
  'PROJECT_UPDATE_REPLY',
  'ATTACHMENT',
  'WORK_RELATION',
  'REQUEST_WORK_LINK',
]);
export const MindDocument = z.strictObject({
  sourceId: z.string(),
  entityKind: MindEntityKind,
  entityId: z.string(),
  rootWorkId: z.uuid().nullable(),
  projectId: z.uuid(),
  canonicalUrl: z.url(),
  title: z.string(),
  text: z.string(),
  effectiveVisibility: z.literal('COMPANY'),
  metadata: z.record(z.string(), z.json()),
  jiraMappings: z.array(
    z.strictObject({
      sourceInstance: z.string(),
      entityKind: z.string(),
      sourceId: z.string(),
      sourceKey: z.string().nullable(),
    }),
  ),
  contentHash: z.string().regex(/^[a-f0-9]{64}$/),
});
/** This machine-only response is not the ordinary REST data/meta envelope. */
export const MindSnapshot = z.strictObject({
  schemaVersion: z.literal(1),
  sourceInstance: z.string(),
  scope: z.strictObject({
    policy: z.literal('effective-company-only-v1'),
    projectIds: z.array(z.uuid()).min(1).max(10),
  }),
  snapshotId: z.uuid(),
  generatedAt: z.iso.datetime(),
  documents: z.array(MindDocument).max(50000),
  completion: z.strictObject({
    complete: z.literal(true),
    documentCount: z.number().int().nonnegative(),
    countsByKind: z.record(z.string(), z.number().int().positive()),
    documentsHash: z.string().regex(/^[a-f0-9]{64}$/),
  }),
});
